module Bookhus.Widgets {

    export class Bookingkalender {

        private containerId: string;
        private inputfieldId: string;
        //private hideInputfield: boolean;
        private selectedDate: Date;
        private dateShown: Date;
        private translations: Bookhus.Localization.Calendar;
        public daystatusService: ICalendarDaydataService;
        private parameters: IBookingkalenderParameters;
        private lastGoodDate: Date;
        private bookingPopup: Bookingpopup;

        private redrawEvent: CustomEvent;

        constructor(inputfieldId: string, parameters: IBookingkalenderParameters) {
            this.inputfieldId = inputfieldId;
            this.parameters = parameters;
            //this.hideInputfield = hideInputfield;
            if (this.parameters === undefined) {
                this.parameters = this.getDefaultparameters();
            }

            this.redrawEvent = new CustomEvent(inputfieldId + "_redraw", { bubbles: true });

            this.translations = new Bookhus.Localization.Calendar();
            if (this.parameters.showHandleBookingsButton) {
                this.bookingPopup = new Bookingpopup(this.parameters.currentCulture, false, false, this.parameters.hasEventModule);
            } else {
                this.bookingPopup = null;
            }

            this.getSelectedDate();
            this.daystatusService = new CalendarDaydataService(this.parameters.minBookingBorder, this.parameters.mediumBookingBorder, this.parameters.currentUserId, true, this.parameters.separateTime, this.parameters.calendarStatusDisplayMode);

            this.loadDataAndRedraw();

            //this.createCalendar();
        }

        private getDefaultparameters(): IBookingkalenderParameters {
            var parameters: IBookingkalenderParameters = {
                currentCulture: "da",
                hideInputfield: true,
                houseId: 0,
                currentUserId: 0,
                mediumBookingBorder: 10,
                minBookingBorder: 5,
                reservationRestrictions: true,
                monthbarLabel: null,
                showHandleBookingsButton: false,
                isDayOpen: [true, true, true, true, true, true, true],
                separateTime: 12,
                hasEventModule: false,
                showDaysBeforeTodayAsBooked: false,
                showDaysAfterTodayAsBooked: 0,
                isAdmin: false,
                isExternalUser: false,
                datechanged: null,
                earliestYear: null,
                latestYear: null,
                showLockInfo: false,
                calendarStatusDisplayMode: CalendarStatusDisplayMode.Default
            };

            return parameters;
        }

        private loadDataAndRedraw() {
            var daysInMonth = this.daysInMonth(this.dateShown.getMonth() + 1, this.dateShown.getFullYear());
            var startdate = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), 1).addDays(-7);
            var enddate = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), daysInMonth).addDays(7);


            var xhr = this.daystatusService.loadDataAjax(this.parameters.houseId, startdate, enddate);
            var self = this;
            xhr.always(function (jqxhr, textStatus, error) {
                //$("#status").html(textStatus + " " + error);
                self.createCalendar();
                
                //document.dispatchEvent(self.redrawEvent);
                document.dispatchEvent(new CustomEvent(self.containerId + "_redraw", { bubbles: true, detail: { showndate: self.dateShown } }));
            });
        }

        private getSelectedDate() {
            var inputfield = $("#" + this.inputfieldId);
            if (inputfield === undefined || inputfield === null) {
                throw new Error("Datofeltet findes ikke");
            }

            var date = $.datepicker.parseDate(this.translations.get('dateFormat', this.parameters.currentCulture), inputfield.val());
            if (date < new Date(2000, 1, 1)) {
                date = new Date(Date.now());
            }

            this.selectedDate = date;
            //this.dateShown = this.selectedDate;
            this.dateShown = new Date(date.getTime()); // <-- super vigtigt at dateShown og selectedDate får forskellige adresser i hukommelsen..
            this.lastGoodDate = new Date(date.getTime());
        }

        private createCalendar() {
            var inputfield = $("#" + this.inputfieldId);
            this.containerId = this.inputfieldId + "_calendar";

            if (this.parameters.hideInputfield) {
                inputfield.hide();
            }

            //if (!this.dateIsAllowed()) {
            //    return;
            //}

            $("." + this.containerId).remove();

            var calendar = $(`<div class="${this.containerId} bc"></div>`).insertAfter(inputfield);

            // lav måned og årstal kasse, plus frem og tilbagepile
            this.createMonthYearBar(calendar);

            // lav tabel med alle dagene
            this.createTabelWithDays(calendar);

            if (this.bookingPopup !== null) {
                this.createHandleBookingsButton();
            }
        }

        private createTabelWithDays(calendar: JQuery) {

            var self = this;
            

            var days = this.daysInMonth(this.dateShown.getFullYear(), this.dateShown.getMonth() + 1);
            var i: number;
            var dayofweek: number;

            // der skal altid være 7 kolonner, men hvor mange rækker skal vi lave?
            var coloffset = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), 1).getDay() - 1;
            if (coloffset < 0) {
                coloffset = 6;
            }
            var rows = (days + coloffset) / 7;

            // Hvad dag skal vi starte på? dayCounter = 1 starter den første i måneden
            // dayCounter 0 starter sidste dag i måneden før -1 to dage før osv..
            var dayCounter = 1;
            dayCounter -= coloffset;

            var today = new Date().getDateWithoutTime().addDays(self.parameters.showDaysAfterTodayAsBooked);

            // Løb rækkerne igennem
            var calendarWeeks = '';
            for (var r = 0; r < rows; r++) {
                //Start new calendar row
                calendarWeeks += '<div class="weekCs d-flex flex-row text-nowrap">';

                // Find ugenummeret og set det ind
                var currentWeek = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), dayCounter).getWeek();
                calendarWeeks += `<div class="weekCount">${currentWeek}</div>`;
                calendarWeeks += `<div class="calenderDays d-flex flex-row justify-content-center">`;

                var selectedMonth = this.dateShown.getMonth();
                var currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                // Løb dagene i denne uge igennem
                for (i = 0; i < 7; i++) {
                    dayofweek = i;
                    if (dayofweek === 7) {
                        dayofweek = 0;
                    }

                    var currentDay = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), dayCounter++);

                    var dayEventStatus = this.getDayEventstatus(currentDay);

                    if (selectedMonth !== currentDay.getMonth()) {
                        calendarWeeks += `
                            <div class="${dayEventStatus}"><div data-date="${currentDay.toString("dd-MM-yyyy")}" class="day not-current-month">
                                <span>${currentDay.toString("dd")}</span>
                            </div></div>`;
                    } else {
                        var dayStatus = this.getDaystatus(currentDay, this.parameters.isExternalUser);
                        var dayHasPrice = this.getDayHasPrice(currentDay);
                        if (!dayHasPrice && dayStatus.indexOf("reservation") === -1) {
                            dayStatus = "noprice";
                        }
                        var dayActive = "";
                        var dateToCheck = currentDay;
                        dateToCheck.setHours(0, 0, 0, 0);
                        var disableSysMaxForDay = this.daystatusService.sysMaxDateGælderIkkeForLodtrækninger && dayStatus.indexOf('drawperiod') > -1;
                        if ((this.parameters.reservationRestrictions && (!dayHasPrice || currentDay < this.daystatusService.mindate || (currentDay > this.daystatusService.houseOpenUntill && !disableSysMaxForDay)) || (dateToCheck < currentDate && this.parameters.reservationRestrictions) || dayStatus.indexOf('restrictedPeriod') > -1) ||
                            this.parameters.isDayOpen[dayofweek] === false) {
                            dayActive = "day-not-active";
                        }
                        dayStatus = dayStatus.replace('restrictedPeriod', '');

                        var containerStatus = "";
                        if (currentDay.getTime() === this.selectedDate.getTime()) {
                            containerStatus += " selected";
                        }

                        var title = "";
                        if (dayStatus.indexOf("locked") > -1 && !this.parameters.showLockInfo && !this.parameters.isAdmin) {
                            dayStatus = dayStatus.replace("locked", "reservation");
                        }
                        else if (dayStatus.indexOf("locked") > -1 && this.parameters.showLockInfo && this.parameters.isAdmin) {
                            title = this.translations.get('periodIsLocked', this.parameters.currentCulture) + '. ' + this.translations.get('clickForMoreInformation', this.parameters.currentCulture);
                        }
                        else if (dayStatus.indexOf("locked") > -1 && this.parameters.showLockInfo) {
                            title = this.translations.get('periodIsLocked', this.parameters.currentCulture);
                        }

                        if (!self.parameters.isAdmin && self.parameters.showDaysBeforeTodayAsBooked && currentDay.getDateWithoutTime().getTime() < today.getTime()) {
                            dayStatus = "reservation";
                            title = "";
                        }

                        calendarWeeks += `
                            <div class="${dayEventStatus}"><div data-date="${currentDay.toString("dd-MM-yyyy")}" data-title="${title}" class="day ${dayStatus} ${dayActive} ${containerStatus}">
                                <span>${currentDay.toString("dd")}</span>
                            </div></div>`;
                    }
                }

                calendarWeeks += "</div>";
                calendarWeeks += "</div>";
            }

            calendar.append(`
                <div class="bc-body rounded-bottom">
                    <div class="bc-list-view">
                        <div class="row no-gutters">
                            <div class="bc-list-item-calendar inline col-12">
                                <div class="monthCs">
                                    ${calendarWeeks}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `);

            this.hookupCalendarClickevents(calendar);
        }

        private hookupCalendarClickevents(calendar: JQuery) {
            // sæt klik event
            var self = this;
            calendar.children().find(".day:not(.not-current-month)").click(function () {
                var day = parseInt($(this).find("span").text());
                var date = new Date(self.dateShown.getFullYear(), self.dateShown.getMonth(), day);
                self.selectedDate = date;

                $("." + self.containerId + " .selected").removeClass("selected");
                $(this).addClass("selected");

                $("#" + self.inputfieldId).val(self.selectedDate.formatDate(self.translations.get('dateFormat', self.parameters.currentCulture)));
                $("#" + self.inputfieldId).trigger("change");
                if (self.bookingPopup !== null) {
                    self.updateHandleBookingsButton();
                }
            });

            const TOOLTIP_DELAY: number = 500;
            const TOOLTIP_TIMEOUT: string = 'tooltipTimeout';

            calendar.find('.day:not(".day-not-active")').on('mouseenter', (e) => {
                var $target = $(e.currentTarget);
                clearTimeout($target.data(TOOLTIP_TIMEOUT));
                $target.data(TOOLTIP_TIMEOUT, setTimeout(() => {
                    $target.off('mouseenter');

                    var title = $target.data('title');
                    if (!this.parameters.isAdmin && title) {
                        displayTooltip($target, title);
                    }
                    else {
                        var dateString = $target.attr("data-date").split("-");
                        var bookingDate = new Date(+dateString[2], +dateString[1] - 1, +dateString[0]);
                        this.daystatusService.getTitleForDay(bookingDate).then((status) => {
                            if (!status) {
                                return;
                            }
                            displayTooltip($target, status);
                        });
                    }                    
                }, TOOLTIP_DELAY));
            });

            calendar.find('.day:not(".day-not-active")').on('mouseleave', (e) => {
                var $target = $(e.currentTarget);
                clearTimeout($target.data(TOOLTIP_TIMEOUT));
            });

            function displayTooltip($target: JQuery, title: string) {
                $target.tooltip({
                    title: title,
                    trigger: 'hover',
                    delay: { show: TOOLTIP_DELAY, hide: 0 }
                } as any);

                $target.on('click', function () {
                    $(this).tooltip('hide');
                });
                $target.tooltip('show');
            }
        }

        private createMonthYearBar(calender: JQuery) {
            calender.append(`
                <div class="bc-header rounded-top">
                    <div class="row no-gutters p-2">
                        <div class="col">
                            <span class="bc-header-title transform-center font-weight-bold">
                                ${this.parameters.monthbarLabel}
                            </span>
                            <span class="dropdown d-inline-block float-right">
                                <button type="button" class="btn btn-light bg-transparent" data-toggle="dropdown">
                                    <i class="far fa-calendar-alt"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right px-4 py-3">
                                    <form class="form-inline flex-nowrap" id="changeSelecedDate">
                                        ${this.createMonthDropdown()} ${this.createYearDropdown()} <button type="submit" class="btn btn-primary">Vis</button>
                                    </form>
                                </div>
                            </span>
                        </div>
                    </div>
                    <div class="row no-gutters p-2">
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-dark prev float-left">
                                <span class="fa fa-chevron-left"></span>
                            </button>
                        </div>
                        <div class="col text-center font-weight-bold">
                            <span class="bc-header-title">${this.translations.getValues('monthNames', this.parameters.currentCulture)[this.dateShown.getMonth()]} ${this.dateShown.getFullYear()}</span>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-dark next">
                                <span class="fa fa-chevron-right"></span>
                            </button>
                        </div>
                    </div>
                    <div class="row no-gutters">
                        <div class="bc-header-calendar inline col-12">

                        </div>
                    </div>
                </div>
            `);

            // uge dage
            var weekDays = '';
            for (var i = 1; i <= 7; i++) {

                var text = "";
                var backgroundColor = "bg-light";
                var textColor = "text-primary";
                if (i == 6 || i == 7) {
                    backgroundColor = "bg-holiday";
                    textColor = "text-light";
                }

                weekDays += `
                    <div class="day col calenderdate ${backgroundColor} ${textColor}">
                        <span>${this.translations.getValues('dayNamesMin', this.parameters.currentCulture)[i % 7]}</span>
                    </div>
                `;
            }

            $('.bc-header .bc-header-calendar', calender).empty()
                .append(`
                    <div class="monthCs">
                        <div class="weekCs d-flex flex-row text-nowrap">
                            <div class="weekCount">${this.translations.get('weekHeader', this.parameters.currentCulture)}</div>
                            <div class="calenderDays d-flex flex-row justify-content-center">${weekDays}</div>
                        </div>
                    </div>
                `);

            calender.find(".prev").on("click", () => {
                this.moveMonth(-1);
            });

            calender.find(".next").on("click", () => {
                this.moveMonth(1);
            });

            calender.find('#changeSelecedDate').on('submit', (e) => {
                e.preventDefault();
                e.stopPropagation();

                var $form = $(e.target);
                var selectedMonth = $('select[name="month"]', $form).val();
                var selectedYear = $('select[name="year"]', $form).val();
                this.moveToMonthInYear(selectedMonth, selectedYear);
                $form.parents('.dropdown').dropdown('hide');
            });
        }

        private createMonthDropdown(): string {
            var monthDrop = "";
            this.translations.getValues('monthNames', this.parameters.currentCulture).forEach((month, index) => {
                var selected = index === this.dateShown.getMonth() ? ' selected="selected"' : "";
                monthDrop += `<option value="${index}"${selected}>${month}</option>`;
            });
            return `<select class="form-control mr-2" name="month">${monthDrop}</select>`;
        }

        private createYearDropdown(): string {
            var yearDrop = "";
            var yearsBack = -5;
            var yearsForward = 5;
            for (var i = yearsBack; i <= yearsForward; i++) {
                var currentYear = this.dateShown.getFullYear() + i;
                var selected = currentYear === this.dateShown.getFullYear() ? ' selected="selected"' : "";
                yearDrop += `<option value="${currentYear}"${selected}>${currentYear}</option>`;
            }
            return `<select class="form-control mr-2" name="year">${yearDrop}</select>`;
        }

        private createHandleBookingsButton(): void {
            if ($("#handleBookingsButton").length <= 0) {
                $(".Arrivaldate_calendar").after(`
                    <div class="text-center mt-2">
                        <button type="button" class="btn btn-outline-primary btn-sm " id="handleBookingsButton">${this.translations.get('handleBookings', this.parameters.currentCulture)} <span id="handleBookingsText"></span></button>
                    </div>
                `);
                var self = this;
                $("#handleBookingsButton").on("click", function () {
                    var dateString = $(this).find("#handleBookingsText").html().split("-");
                    var bookingDate = new Date(+dateString[2], +dateString[1] - 1, +dateString[0]);
                    self.bookingPopup.showPopup(self.parameters.houseId, bookingDate, true);
                });
            }
            this.updateHandleBookingsButton();
        }

        private updateHandleBookingsButton(): void {
            $("#handleBookingsText").html(this.selectedDate.toString("dd-MM-yyyy"));
        }

        // -1 = en måned tilbage, +1 = en måned frem, 0 = brug måned som står i #currentMonth
        private moveMonth(direction) {
            this.lastGoodDate = new Date(this.dateShown.getTime());

            this.dateShown.setDate(1);
            this.dateShown.setMonth(this.dateShown.getMonth() + direction);
            this.loadDataAndRedraw();

            if (this.parameters.datechanged && typeof this.parameters.datechanged == 'function') {
                this.parameters.datechanged(this.dateShown);
            }
        }

        private moveToMonth(target) {
            this.lastGoodDate = new Date(this.dateShown.getTime());

            this.dateShown.setDate(1);
            this.dateShown.setMonth(target);
            this.loadDataAndRedraw();
        }

        private moveToYear(target: number): void {
            this.dateShown.setDate(1);
            this.dateShown.setFullYear(target);
            this.loadDataAndRedraw();
        }

        public moveToMonthInYear(targetMonth: number, targetYear: number) {
            if (targetMonth < 0 || targetMonth > 11) {
                throw new Error("Ugyldig måned. Angiv 0 til 11.");
            }
            if (targetYear < 2000 || targetYear > 2100) {
                throw new Error("Ugyldigt år angivet.");
            }

            this.dateShown.setDate(1);
            this.dateShown.setMonth(targetMonth);
            this.dateShown.setFullYear(targetYear);
            this.loadDataAndRedraw();
        }

        private daysInMonth(year: number, month: number): number {
            return new Date(year, month, 0).getDate();
        }

        private getDaystatus(date: Date, includeChannelPeriods: boolean): string {
            if (this.daystatusService === undefined) {
                return "empty";
            }
            return this.daystatusService.getStatusForDay(date, includeChannelPeriods);
        }

        private getDayEventstatus(date: Date): string {
            if (this.daystatusService === undefined) {
                return "";
            }
            return this.daystatusService.getEventstatusForDay(date);
        }

        private getDayHasPrice(date: Date): boolean {
            if (this.daystatusService === undefined) {
                return true;
            }
            return this.daystatusService.dayHasPrice(date);
        }

        setHouseIdAndRedraw(houseId): void {
            this.parameters.houseId = houseId;
            this.loadDataAndRedraw();
        }
    }
}
